import { type IIconsVector } from 'shared/ui'
import { type IWorkflowTemplate } from 'pages/workflows/ui/CreateWorkflowModal/model/WorkflowTemplate'

export const TemplateName = {
  FromScratch: 'Start from scratch',
  AutoResponder: 'Autoresponder',
  NurtureCampaign: 'Nurture Campaign',
  Reviews: 'Reviews',
  SendMessage: 'Send a Message',
  AppointmentReminder: 'Appointment Reminder',
  NPS: 'NPS',
  Integrations: 'Integrations',
  SmsReminder: 'SMS Reminder',
} as const

export type IWorkflowTemplateName = (typeof TemplateName)[keyof typeof TemplateName]

export type IWorkflowTemplateView = {
  icon: IIconsVector
  name: IWorkflowTemplateName
  description: string
  disabled?: true
}

export type ICreateWorkflowProps = {
  workflow: IWorkflowTemplate
  onNext: () => void
  onClose: () => void
}
